import { render, staticRenderFns } from "./OtherServiceExpenditure.vue?vue&type=template&id=0503f370"
import script from "./OtherServiceExpenditure.vue?vue&type=script&lang=js"
export * from "./OtherServiceExpenditure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports